// extracted by mini-css-extract-plugin
export var text = "_73-0";